import styled from 'styled-components';
import { SIZE } from '@app/src/ui';

interface Props {
  isShow: boolean;
}

export const Wrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  display: none;
  background: #FAFAFA;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 16px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    padding: 0 10px;
    height: 70px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3);
    display: ${(props:Props) => props.isShow
      ? 'flex'
      : 'none'};

    a {
      max-width: 275px;
    }
  }

  @media (min-width: ${SIZE.DESKTOP} ) {
    padding: 0 25px;
  }
`;

const MAIN = 'Header';
Wrapper.displayName = `${MAIN}/Wrapper`;
